<template>
  <div>
    <div class="image-item" @click="$emit('open-popup',image)">
      <img :src="imageUrl"
           @error="onImgError">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageNavigatorImageItem',
  props: {
    image: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageUrl() {
      return this.image.file_urls ? this.image.file_urls.thumbnail : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.image-item {
  position: relative;
  width: 100%;
  padding-top: 138.5%;
  overflow: hidden;
  cursor: pointer;
  background: #ccc;
  border-radius: 4px;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
  }
}

</style>
